import { css } from '@emotion/core'

export default {
  controlsRow: css`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap-reverse;
    margin-bottom: -12px;
  `,
  rawData: css`
    padding: 0 12px;
    overflow-x: auto;
  `,
}
